import {Controller} from "@hotwired/stimulus"
import SnakeGame from "../snake"

export default class extends Controller {
    connect() {
        this.game = new SnakeGame()
        this.game.start()
    }

    disconnect() {
        if (this.game) {
            this.game.end()
        }
    }
}
